import ExistingSignalViewSection from "../SignalViews/ExistingSignalViewSection";
import SignalViewDeleteModal from "../SignalViews/SignalViewDeleteModal";
import SignalViewModal from "../SignalViews/SignalViewModal";
import { Button, Popover, PopoverContent, PopoverTrigger } from "@avenueops/web-components";
import { BookmarkIcon, PlusIcon } from "@heroicons/react/24/outline";
import { ProcessView } from "@prisma/client";
import _ from "lodash";
import React, { useState } from "react";

interface Props {
  signalView?: ProcessView;
}

export default function ProcessTableViewsSection({ signalView }: Props) {
  const [newModalVisible, setNewModalVisible] = useState(false);
  const [updateModalVisible, setUpdateModalVisible] = useState(false);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);

  return (
    <>
      <Popover>
        <PopoverTrigger asChild>
          <Button type="SECONDARY" LeadIcon={BookmarkIcon} size="MEDIUM">
            Views
          </Button>
        </PopoverTrigger>
        <PopoverContent>
          <div className="flex-col flex gap-3">
            <div className="font-medium text-sm whitespace-nowrap">Views</div>
            {!signalView ? (
              <Button onClick={() => setNewModalVisible(true)} type="SECONDARY">
                <PlusIcon className="h-4 w-4 mr-1" />
                Save as View
              </Button>
            ) : (
              <ExistingSignalViewSection
                originalSignalView={signalView}
                setNewModalVisible={setNewModalVisible}
                setUpdateModalVisible={setUpdateModalVisible}
                setDeleteModalVisible={setDeleteModalVisible}
              />
            )}
          </div>
        </PopoverContent>
      </Popover>
      {newModalVisible && (
        <SignalViewModal
          setModalVisible={setNewModalVisible}
          modalVisible={newModalVisible}
          starterCsvRecipients={signalView?.csvExportEmailRecipients}
          starterTitle={signalView?.title ?? undefined}
        />
      )}
      {updateModalVisible && signalView ? (
        <SignalViewModal
          setModalVisible={setUpdateModalVisible}
          modalVisible={updateModalVisible}
          id={signalView.id}
          starterCsvRecipients={signalView.csvExportEmailRecipients}
          starterTitle={signalView.title}
        />
      ) : null}
      {deleteModalVisible && signalView ? (
        <SignalViewDeleteModal setModalVisible={setDeleteModalVisible} modalVisible={deleteModalVisible} signalView={signalView} />
      ) : null}
    </>
  );
}
